<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import moment from 'moment';
import DblogsTable from './DblogsTable';


export default {
  page: {
    title: 'DB logs',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, DblogsTable },
  data() {
    let $this = this;
    return {
      title: 'DB logs',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'DB logs', active: true, },
      ],

      pickeroptions: {
        shortcuts: [
          { text: 'This week', onClick (picker) { picker.$emit('pick', [moment().startOf('week').toDate(), moment().endOf('week').toDate()]); } },
          { text: 'Last week', onClick (picker) { picker.$emit('pick', [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()]); } },
          { text: 'This month', onClick (picker) { picker.$emit('pick', [moment().startOf('month').toDate(), moment().endOf('month').toDate()]); } },
          { text: 'Last month', onClick (picker) { picker.$emit('pick', [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]); } },
          { text: 'This year', onClick (picker) { picker.$emit('pick', [moment().startOf('year').toDate(), moment().endOf('year').toDate()]); } },
          { text: 'Last year', onClick (picker) { picker.$emit('pick', [moment().subtract(1, 'year').startOf('year').toDate(), moment().subtract(1, 'year').endOf('year').toDate()]); } },
          { text: 'All time', onClick (picker) { picker.$emit('pick', [moment().set('year', 2016).toDate(), moment().toDate()]); } },
          { text: 'Clear', onClick (picker) { try { $this.$refs['picker1'].clearDate(); } catch(err) { console.log(err); } } },
        ]
      },
      dateRange: ['',''],
      search: '',

      show_filters: false,
      changes: false,

      loading: true,
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        withs: { user: { total: 0, selects: ['id','name','email','phone','avatar'], norelations: 1, }, },
        whereins: {
          website: [],
        },
        notins: {
          type: [],
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {

        },
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n[0] && n[1] && moment(n[0]).isValid() && moment(n[1]).isValid()) {
        this.filters.betweens.created_at.start = moment(n[0]).startOf('day').format();
        this.filters.betweens.created_at.end = moment(n[1]).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.$refs['DblogsTable'].fetchData(); } }
  },
  created() {

  },
  methods: {

  }
}
</script>


<template>
  <Layout>
    <router-view v-show="$route.params.id"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <transition name="fade">
              <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
            </transition>
            <div class="px-4 pt-4 pb-3">
              <div class="row">
                <div class="col-lg-8">
                  <div class="form-inline">
                    <button type="button" @click="$refs['DblogsTable'].fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
                    <div class="form-group mr-2 mb-2">
                      <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
                    </div>
                    <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
                    <div class="form-group mr-2 mb-2">
                      <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                        <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                        <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
                      </button>
                    </div>
                    
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="text-lg-right mt-3 mt-lg-0">
                    
                  </div>
                </div>
              </div>
            </div>
            <transition name="fade">
              <div v-if="show_filters" class="p-4 bg-gray-200">
                <div class="form-inline">
                  <div class="form-group mr-2">
                  <v2-datepicker-range lang="en" format="MM-DD-yyyy" ref="picker1" v-model="dateRange" :picker-options="pickeroptions" placeholder="Filter by date created..." @change="changes = true"></v2-datepicker-range>
                </div>
                <div class="form-group mr-2">
                  <select class="form-control" v-model="filters.paginate">
                    <option value="50">Per page: (50)</option>
                    <option value="100">Per page: (100)</option>
                    <option value="250">Per page: (250)</option>
                    <option value="500">Per page: (500)</option>
                    <option value="750">Per page: (750)</option>
                    <option value="1000">Per page: (1000)</option>
                  </select>
                </div>
                </div>
                
                <div class="mt-3">
                  <label class="">Exclude types :</label>
                  <div class="table-responsive m-0">
                    <table class="table sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
                      <tbody>
                        <tr v-for="(fil, fil_i) in filters.notins.type" :key="fil_i">
                          <td class="p-0 w-100">
                            <input type="text" class="form-control _w-n-120 w-100" v-model="filters.notins.type[fil_i]" placeholder="Exception type..." v-tippy content="Please enter the expection type you wish to exclude.">
                          </td>
                          <td class="p-0">
                            <button type="button" class="btn btn-white" @click="filters.notins.type.splice(fil_i, 1)"><Icon icon="ri:delete-bin-7-line" /></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="mt-1">
                    <button type="button" class="btn btn-sm btn-success" @click="filters.notins.type.push('')"><Icon icon="ri:add-line" /> Add</button>
                  </div>
                </div>

              </div>
            </transition>
            <transition name="fade">
              <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line"></Icon> commit any changes made to filters.</div>
            </transition>
            <div class="row">
              <div class="col-sm-12">
                <DblogsTable ref="DblogsTable" :filters="filters" @loadchange="(e) => {loading = e; (!e ? changes = e : '')}"></DblogsTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


